module.exports = __webpack_public_path__ + "img/icpieces.3e08d14c.png";